/**
 * @module isActionableMessageV2Enabled
 */

import { isFeatureEnabled } from 'owa-feature-flags';

const isActionableMessageV2Enabled = () => {
    return isFeatureEnabled('rp-actionableMessages-ACv2-support');
};

export default isActionableMessageV2Enabled;
